import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';
import * as IconC from './_ccbIconC';

import { useAny, useDz } from './_csLcl';

const _CbxC = React.memo((pz: ht.cbxSglSglCz) => {

  const _sVle = useAny(-1);
  React.useEffect(() => {
    if (pz.cz?.vle) {
      _sVle.set(pz.cz?.vle);
    }
  }, [
    pz.cz?.vle
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.cbxAbtz[_abtType] ? ica.cbxAbtz[_abtType]() : {};

  const _onChg = () => {
//    if (pz.cz?.bEdit != false) {
      const _vle = _sVle.crt == 1 ? -1 : 1;
      _sVle.set(_vle);
      if (pz.cz?.onChg) pz.cz?.onChg(_vle);
//    }
  };

  return (
    cr.c(BoxC.N, {
      key: 'Btn.root',
      boxStlz: {
        ... _abtz?.boxStlz,
        ... pz.boxStlz,
      },
      pslPtyz: 
        pz.cz?.bEdit != false ?
        {
          onPress: _onChg,
        }
        : null,
      oClds: [
        _sVle.crt == 1 ?
        cr.c(IconC.N, {
          key: -10,
          iconPtyz: {
            ... _abtz?.cbxCz?.iconPtyz?.sctz,
            ... pz.cbxCz?.iconPtyz?.sctz,
          },
          boxStlz: {
            ... _abtz?.cbxCz?.boxStlz?.sctz,
            ... pz.cbxCz?.boxStlz?.sctz,
          },
        })
        : null,
        _sVle.crt != 1 ?
        cr.c(IconC.N, {
          key: -10,
          iconPtyz: {
            ... _abtz?.cbxCz?.iconPtyz?.nmlz,
            ... pz.cbxCz?.iconPtyz?.nmlz,
          },
          boxStlz: {
            ... _abtz?.cbxCz?.boxStlz?.nmlz,
            ... pz.cbxCz?.boxStlz?.nmlz,
          },
        })
        : null,
        pz.lblCz ?
        cr.c(TextC.N, {
          key: -20,
          textz: {
            ... pz.lblCz.textz,
            stlz: {
              ... _abtz?.lblCz?.textz?.stlz,
              ... pz.lblCz?.textz?.stlz,
            },
          },
          boxStlz: _abtz?.lblCz?.boxStlz,
        })
        : null,

      ]
    })
  );
});

export const SS = _CbxC;

export const MS = (pz: ht.cbxMplSglCz) => { // checkbox multiple choice single select
  const _sDz = useDz();
  React.useEffect(() => {
    //hf.l(`cbx 101: ${pz.cz.vle}`)
    _sDz.rlc({[pz.cz.vle]: 1}); 
  }, [
    pz.cz.vle,
  ]);
  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.cbxMmAbtz[_abtType] ? ica.cbxMmAbtz[_abtType]() : {};
  return (
    cr.c(BoxC.N, {
      key: 'Cbx.MS.root',
      boxStlz: _abtz.boxStlz,
      oClds: pz.cz.ls.map( (_dz, _idx) => {
/*
        const _onChg = ( _vle: ht.n ) => {
          const _dz2 = {
            [_dz.key]: _vle,
          }
          _sDz.rlc(_dz2);
          if ( pz.cz.onChg ) pz.cz.onChg( _vle ? _dz.key : -1 );
        };
*/
        const _onChg = () => {
          _sDz.rlc({
            [_dz.key]: 1,
          });
          if ( pz.cz.onChg ) pz.cz.onChg(_dz.key);
        };
        return (
          cr.c(_CbxC, {
            key: _idx,
            cz: {
              ... pz.cz,
              bEdit: 
                _sDz.crt[_dz.key] != 1 ?  // off を不可とする
                  pz.cz.bEdit 
                : false,
              vle: _sDz.crt[_dz.key] ?? -1,
              onChg: _onChg,
            },
            lblCz: {
              textz: {
                pfx: _dz.pfx,
              },
            },
            boxStlz: _abtz.lz?.boxStlz,
          })
        );
      })
    })
  );
};

export const MM = (pz: ht.cbxMplMplCz) => { // checkbox multiple choice multiple select
  const _sDz = useDz();
  React.useEffect(() => {
    _sDz.set(pz.cz.vlez); 
  }, [
    pz.cz.vlez,
  ]);
  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.cbxMmAbtz[_abtType] ? ica.cbxMmAbtz[_abtType]() : {};
  return (
    cr.c(BoxC.N, {
      key: 'Cbx.MM.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      oClds: hf.nn(pz.cz.ls).map( (_dz, _idx) => {
        const _onChg = ( _nVle: ht.n ) => {
          const _dz2 = {
            ... _sDz.crt,
            [_dz.key]: _nVle,
          }
          // hf.l(`_cccCbxC 151: ${hf.s(_dz)}`);
          _sDz.set({ [_dz.key]: _nVle });
          if ( pz.cz.onChg ) {
            // hf.l(`_cccCbxC 154: ${hf.s(_dz2)}`);
            pz.cz.onChg(_dz2);
          }
        };
        return (
          cr.c(_CbxC, {
            key: _idx,
            cz: {
              ... pz.cz,
//              nVle: _sDz.crt[_dz.key],
              vle: _sDz.crt[_dz.key],
              onChg: _onChg,
            },
            lblCz: {
              textz: {
                pfx: _dz.pfx,
              },
            },
            boxStlz: _abtz.lz?.boxStlz,
          })
        );
      })
    })
  );
};
